export default __webpack_public_path__ + "static/media/profile.f4e11cbd.jpg";